export default function FilterPanel({
  children,
  fixedMenuPosition,
  dropDirection,
}) {
  return (
    <div
      className={`hitq-panel ${
        fixedMenuPosition
          ? "hitq-panel-fixed"
          : `hitq-panel-absolute hitq-panel-${dropDirection}`
      }`}
    >
      <div className="hitq-panel-content">{children}</div>
    </div>
  );
}
